module.exports = __webpack_public_path__ + "img/privilegeright.d12084a4.png";